/// <reference types="./releaseAdvisoryLock.d.ts" />
import { notOk, ok, } from '@dossierhq/core';
export async function releaseAdvisoryLock(databaseAdapter, context, name, handle) {
    const { logger, session } = context;
    if (session.type === 'readonly') {
        return notOk.BadRequest('Readonly session used to release advisory lock');
    }
    const result = await databaseAdapter.advisoryLockRelease(context, name, handle);
    if (result.isError())
        return result;
    logger.info(`Released advisory lock: ${name}`);
    return ok({ name });
}
//# sourceMappingURL=releaseAdvisoryLock.js.map